import styled from '@emotion/styled';

import { Box } from '@mui/material';

export const ErrorBoundaryStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
});

export const ErrorBoundaryTextStyled = styled.span();
